module.exports = __webpack_public_path__ + "img/award-4.6b98882d.png";